/** Lime progress bar (§5.4): 4px tall, radius 0, machine-eased. Shows the work. */
export function ProgressBar({ value, label }: { value: number; label?: string }) {
  const pct = Math.max(0, Math.min(100, Math.round(value)));
  return (
    <div
      className="h-1 w-full overflow-hidden rounded-none bg-surface-3"
      role="progressbar"
      aria-valuenow={pct}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-label={label}
    >
      <div className="h-full bg-accent transition-[width] duration-base ease-machine" style={{ width: `${pct}%` }} />
    </div>
  );
}
